// export const server = "http://localhost:5000/api/v2";
// export const server = "https://app.ninetyone.co.ke/api/v2";
export const server = "https://oauth-eosin.vercel.app/api/v2";
// export const server = "https://onlineshop-delta-three.vercel.app/api/v2";
// export const server2 = "https://whatsapp-delta-nine.vercel.app";
